import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "src/app/services/auth/auth.service";
import { LoaderService } from "src/app/services/loader/loader.service";
import { ExceptionsService } from "src/app/exceptions/exceptions.service";
import { StorageService } from "src/app/services/storage/storage.service";
import { RouterService } from "src/app/services/router/router.service";
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { AlertService } from "src/app/services/alert/alert.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { UserService } from "src/app/services/user/user.service";
import { MustMatch } from "src/app/helpers/must-match.validator";
import { Platform } from "@ionic/angular";

@Component({
  selector: "app-auth-confirmation",
  templateUrl: "./auth-confirmation.page.html",
  styleUrls: ["./auth-confirmation.page.scss"],
})
export class AuthConfirmationPage implements OnInit {
  messageError: any;
  resetPasswordObject: any;
  buttonToLogin = false;
  LOADER_ID = "auth-confirmation";
  mode: "reset" | "recovery" | "verify";
  confirmationForm: FormGroup;
  accountEmail: string;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private loaderService: LoaderService,
    private exceptionService: ExceptionsService,
    private storageService: StorageService,
    public alertService: AlertService,
    private routerService: RouterService,
    public languageService: LanguagesService,
    private platform: Platform
  ) {
    this.initContructor();
  }

  ngOnInit() {
    if (!this.languageService.loadedLanguage) {
      const language = navigator.language == 'en-US' ? 'en' : 'es';
      this.languageService.loadLanguage(language);
    }
  }

  initContructor() {
    this.route.queryParams.subscribe((params: any) => {
      this.casePWD(params);
    });
    if (
      this.platform.is("android") &&
      (!this.platform.is("mobileweb") || !this.platform.is("desktop"))
    ) {
      this.caseAndroid();
    }
  }

  private initResetForm() {
    this.confirmationForm = this.formBuilder.group(
      {
        password: [
          "",
          Validators.compose([Validators.required, Validators.minLength(8)]),
        ],
        confirmPassword: ["", Validators.required],
      },
      {
        validator: MustMatch("password", "confirmPassword"),
      }
    );
  }

  async handleVerifyEmail(params, time: number) {
    try {
      await this.authService.verifyEmail(params);

      const userFirebase = await this.authService.getUSerInfoFromFirebase();
      if (userFirebase && time) {
        setTimeout(() => {
          this.routerService.redirect("app/home");
        }, time);
      } else if (userFirebase) {
        this.routerService.redirect("app/home");
      }
      return (this.buttonToLogin = true);
    } catch (err) {
      console.log(err, "error al validar email");
      this.routerService.redirect("login");
    }
  }
  async handleRecoverEmail(params) {
    this.loaderService.presentLoading(this.LOADER_ID);
    try {
      await this.authService.verifyEmail(params);
      await this.loaderService.cancelLoader(this.LOADER_ID);
      const userFirebase = await this.authService.getUSerInfoFromFirebase();
      if (userFirebase) {
        return this.routerService.redirect("app/home");
      }
      return (this.buttonToLogin = true);
    } catch (err) {}

    //return this.routerService.redirect("app/home");
    this.loaderService.cancelLoader(this.LOADER_ID);
  }

  handleResetPassword() {
    this.loaderService.presentLoading(this.LOADER_ID);
    this.authService
      .verifyPasswordResetCode(this.resetPasswordObject.oobCode)
      .then((data: string) => {
        this.accountEmail = data;
        //console.log("Email",this.accountEmail );
      })
      .catch((error) => {
        console.log("invalid ", error);
        this.alertService.presentAlert(error?.message);

        this.goToLogin();
      })
      .finally(() => this.loaderService.cancelLoader(this.LOADER_ID));
  }

  saveNewPassword() {
    // Save the new password.
    //console.log("Pass", this.confirmationForm.value.password, this.resetPasswordObject);
    this.loaderService.presentLoading(this.LOADER_ID);
    this.authService
      .confirmPasswordReset(
        this.resetPasswordObject.oobCode,
        this.confirmationForm.value.password
      )
      .then((data) => {
        console.log("password changed");
        this.alertService.presentAlert(
          this.getTextsPageAuthConfirmation.passwordChanged
        );
        this.goToLogin();
        //this.authService.loginWithUserAndPassword(this.accountEmail, this.confirmationForm.value.password).then( ()=> this.goToLogin());
      })
      .catch((error) => {
        console.log("savePassError", error);
      });
    this.loaderService.cancelLoader(this.LOADER_ID);
  }

  // async continueRegisterOnGNX() {
  //   try {
  //     const userGnxCredentials = await this.storageService.get(
  //       "user-gnx-credentials"
  //     );
  //     if (userGnxCredentials) {
  //       const tokenFB = await this.authService.callFbToken();
  //       const tokenGNX = await this.authService.linkUserOnGnx(
  //         tokenFB,
  //         userGnxCredentials.document,
  //         userGnxCredentials.clientCode
  //       );
  //       await this.storageService.set("gnx-token", tokenGNX);
  //       this.routerService.redirect("take-picture");
  //     } else {
  //       await this.removeUser();
  //       await this.authService.logout();
  //       //this.routerService.redirect("login");
  //     }
  //     this.loaderService.cancelLoader(this.LOADER_ID);
  //   } catch (err) {
  //     await this.removeUser();
  //     this.loaderService.cancelLoader(this.LOADER_ID);
  //     //this.routerService.redirect("login");
  //  this.exceptionService.renderError(err);
  //   }
  // }

  async removeUser() {
    await this.authService.removeUserFromFirebase();
  }
  goToLogin() {
    //window.location.href = "https://mvpgnx.page.link/4vDS"
    this.routerService.redirectRoot("app/home");
  }
  get getTextsPageAuthConfirmation() {
    return this.languageService.textsIU["page_auth_confirmation"];
  }
  get getInputError() {
    return this.languageService.textsIU.input_error;
  }

  private resetPassword(params) {
    this.mode = "reset";
    // Display reset password handler and UI.
    this.initResetForm();
    this.resetPasswordObject = params;
    this.handleResetPassword();
  }
  private recoveryEmail(params) {
    this.mode = "recovery";
    // Display email recovery handler and UI.
    this.handleRecoverEmail(params);
  }
  private verifyEmail(params, time?: number) {
    this.mode = "verify";
    this.buttonToLogin = true;
    // Display email verification handler and UI.
    this.handleVerifyEmail(params, time);
  }

  private casePWD(params) {
    console.log(params);
    if (params) {
      switch (params.mode) {
        case "resetPassword":
          this.resetPassword(params);
          break;
        case "recoverEmail":
          this.recoveryEmail(params);
          break;
        case "verifyEmail":
          this.verifyEmail(params);
          break;
        default:
          console.error("mode no encontrado");
          break;
      }
    }
  }
  private caseAndroid() {
    console.log("case android");
    if (this.authService.paramsAuth.mode) {
      switch (this.authService.paramsAuth.mode) {
        case "resetPassword":
          this.resetPassword(this.authService.paramsAuth);
          break;
        case "recoverEmail":
          this.recoveryEmail(this.authService.paramsAuth);
          break;
        case "verifyEmail":
          this.verifyEmail(this.authService.paramsAuth, 3000);
          break;
        default:
          console.error("mode no encontrado");
          break;
      }
    } else {
      console.error("error, no se encontro params de auth firebase");
    }
  }
}

// http://localhost:8100/auth-confirmation?mode=verifyEmail&oobCode=t18Jt6L_-uSIr6p3jvUjljruk751iqxjv6CiC22kmfQAAAF1I-U0gA&apiKey=AIzaSyCzc4umKlI4KtSpgl41U0axBh40Mf-QBYM&lang=en
